import { applyMiddleware, createStore, compose } from "redux";

// eslint-disable-next-line import/no-extraneous-dependencies
import { createLogger } from "redux-logger";

import thunk from "redux-thunk";

import reducers from "./reducers";

const logger = createLogger({ collapsed: true });

const middlewares = [thunk];

if (process.env.NODE_ENV === "development") {
  middlewares.push(logger);
}

// const logger = createLogger({
//   collapsed: true
// });

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const enhancer = middlewareToApply =>
  composeEnhancers(applyMiddleware(...middlewareToApply));

/**
 * getMiddleware, is a function that return redux middlewares, such as thunk, loggers
 * depends on current environment
 * @params listOfMiddlewares - array of middlewares that included in all version
 * @params devEnhancer -func, that apply all middlewares
 * @return middlewares
 */
function getMiddleware(listOfMiddlewares, devEnhancer) {
  if (process.env.NODE_ENV !== "production") {
    return devEnhancer(listOfMiddlewares);
  }
  return applyMiddleware(...listOfMiddlewares);
}

const store = createStore(reducers, getMiddleware(middlewares, enhancer));

export default store;
